














































import { Component, Vue } from 'vue-property-decorator';
import { Mutations, Actions, OverlayMods } from '@/ts/store/Constants';
import BookingData from '@/ts/BookingData';

@Component
export default class BookedSharedFacilities extends Vue {
    constructor() {
        super();
    }

    get activeBookings(): BookingData[] {
        return this.bookings.filter((booking: BookingData) => booking.isActiveBooking && !booking.deletedAt);
    }

    get previousBookings(): BookingData[] {
        return this.bookings.filter((booking: BookingData) => !booking.isActiveBooking || booking.deletedAt);
    }

    get bookings(): BookingData[] {
        return this.$store.getters['SharedFacilities/getUserFacilitiesBookings'];
    }

    public showBookedFacilityInfo(booking: BookingData, status: string) {
        const overlayStatus = status === 'active'
            ? OverlayMods.PreviewBooking.viewActive
            : (booking.deletedAt ? OverlayMods.PreviewBooking.deleted : OverlayMods.PreviewBooking.viewPrevious);

        this.$store.commit(Mutations.SET_BOOKED_FACILITY_OVERLAY_MODE, overlayStatus);
        this.$store.commit(Mutations.SET_USER_SELECTED_BOOKING, booking);
        this.$store.commit(Mutations.SET_BOOKED_FACILITY_OVERLAY_VISIBILITY, true);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_USER_FACILITIES_BOOKINGS);
    }

    public mounted() {
        const bookingId =  this.$route.params.bookingId;
        if (typeof bookingId !== 'undefined') {
            const booking = this.$store.getters['SharedFacilities/getUserBooking'](Number(bookingId));
            const status = booking.isActiveBooking && !booking.deletedAt ? 'active' : 'previous';
            this.showBookedFacilityInfo(booking, status);
        }
    }
}
